import PerformanceArrow from '@cp/src/assets/icons/PerformanceArrow';
import Typography from '@navi/web-ui/lib/primitives/Typography';
import cx from 'classnames';
import styles from './AgencyLeaderboard.module.scss';
import { RootState } from '@cp/src/store';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import CustomLeaderboardBarIcon from '@cp/src/assets/icons/CustomLeaderboardBarIcon';
import { levelIcons } from './constants';
export const PerformanceBar = () => {
  const data = useSelector((state: RootState) => state?.agencyDashboard?.agencyRankingData);
  const isDataValid = () => {
    const agencyAchievementData = data?.achievementPercent / 100;
    return (
      agencyAchievementData >= data?.rankLowerLimit && agencyAchievementData <= data?.rankUpperLimit
    );
  };

  const marginBottomPercent = useMemo(() => {
    if (!isDataValid()) return 0;

    const { achievementPercent, maxLevel, rankLowerLimit, rankUpperLimit, rank } = data || {};
    const agencyAchievementData = achievementPercent / 100;

    const heightPercentFromLowerLimit =
      ((agencyAchievementData - rankLowerLimit) / (rankUpperLimit - rankLowerLimit)) *
      (100 / maxLevel);
    const heightPercentOfLowerLimit = (rank - 1) * (100 / maxLevel);
    return heightPercentOfLowerLimit + heightPercentFromLowerLimit;
  }, [data?.achievementPercent]);

  return (
    <div className="flex justify-center w-full">
      <div className="flex flex-col justify-around items-end h-64 pr-3">
        {levelIcons.map((icon, index) => (
          <Typography
            key={levelIcons?.length - 1 - index}
            variant="p5"
            className="text-right transform scale-200 leading-none"
          >
            {levelIcons[levelIcons?.length - 1 - index]}
          </Typography>
        ))}
      </div>
      <div className="relative h-64">
        <CustomLeaderboardBarIcon height="250" />
        <PerformanceArrow
          style={{
            top: `calc(${100 - (marginBottomPercent || 0)}% - 12px)`
          }}
          className={cx(styles.performanceArrow)}
        />
      </div>
    </div>
  );
};
